import styled from "styled-components";

export const LayerControlMenu = styled.div`
  border-radius: 5px;
  background-color: white;
  display: flex;
  flex-direction: column;
  width: 245px;
`;

export const LayerControlHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 16px 16px 0px 16px;
`;

export const LayerControlTitle = styled.div`
  font-family: Roboto;
  font-size: 13px;
  font-weight: 700;
  align-content: center;
  padding-left: 10px;
`;

export const TileRowsContainer = styled.div<{
  rowCount: number;
}>`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 10px;
  aspect-ratio: ${(props) => `2/${props.rowCount}`};
`;

export const TileRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  aspect-ratio: 2/1;
`;

export const LayerControlContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding-left: 21px;
  padding-bottom: 14px;
  gap: 10px;
  align-items: flex-end;
  border-radius: 16px;
`;

export const LayerControlTile = styled.div<{
  active?: boolean;
  background: string;
}>`
  border: ${(props) =>
    `2px solid ${props.active ? "rgba(0, 117, 188, 1)" : "white"}`};
  box-shadow: ${(props) =>
    `-5px 5px 10px 0px ${
      props.active ? "rgba(0, 117, 188, 0.3)" : "transparent"
    }`};
  width: 81px;
  height: 85px;
  border-radius: 5px;
  background-image: ${(props) => `url(${props.background})`};
  background-size: cover;
`;

export const LayerControlFooter = styled.div`
  position: relative;
  width: 100%;
  top: 66px;
  opacity: 0.8px;
  background-color: rgba(33, 37, 41, 1);
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
`;

export const LayerControlFooterText = styled.span`
  font-family: Roboto;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: white;
  padding-left: 5px;
`;

export const LayerTileContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 50%;
  aspect-ratio: 1/1;
`;

export const LayerTileImageContainer = styled.div`
  height: calc(100% - 36px);
`;

export const LayerTileImage = styled.div<{
  active?: boolean;
  background: string;
}>`
  border: ${(props) =>
    `2px solid ${props.active ? "rgba(0, 117, 188, 1)" : "white"}`};
  box-shadow: ${(props) =>
    `-5px 5px 10px 0px ${
      props.active ? "rgba(0, 117, 188, 0.3)" : "transparent"
    }`};
  height: 100%;
  aspect-ratio: 1/1;
  border-radius: 5px;
  background-image: ${(props) => `url(${props.background})`};
  background-size: cover;
`;

export const LayerTileText = styled.div`
  height: 32px;
  width: 90%;
  font-family: Roboto;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: center;
  color: rgba(33, 37, 41, 1);
`;

export const LayerIconContainer = styled.div`
  padding-left: 5px;
`;
